import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeacherComponent } from './teacher.component';
import { AlertModule } from 'ngx-bootstrap';
import { MasterStructureComponent } from './master-structure/master-structure.component';
import { CreateUserLoginComponent } from './create-user-login/create-user-login.component';
import { PrettyJsonModule } from 'angular2-prettyjson';
import {
  CondictionsMasterTableComponent
} from './master-structure/condictions-master-table/condictions-master-table.component';
import { FiltersFormMasterComponent } from './master-structure/filters-form-master/filters-form-master.component';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';

@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
    PrettyJsonModule,
    AlertModule.forRoot()
  ],
  declarations: [
    TeacherComponent,
    MasterStructureComponent,
    CreateUserLoginComponent,
    CondictionsMasterTableComponent,
    FiltersFormMasterComponent
  ],
})
export class TeacherModule { }



// WEBPACK FOOTER //
// ./src/app/administration/teacher/teacher.module.ts